var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiOperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9738_2946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint0_radial_9738_2946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10.998L3.9004 8.00031L1 5H3.00037L5.9036 8.00031L3.00037 10.998H1ZM11.0188 10.998H6.82056C6.59417 10.9814 6.38285 10.8865 6.22873 10.7321C6.07462 10.5777 5.98903 10.3752 5.98903 10.165C5.98903 9.95485 6.07462 9.75238 6.22873 9.59799C6.38285 9.44361 6.59417 9.34865 6.82056 9.33205H11.016C11.1342 9.32228 11.2533 9.33414 11.3666 9.36698C11.4798 9.3998 11.5849 9.45296 11.6759 9.5234C11.767 9.59384 11.8421 9.68019 11.8971 9.77751C11.9521 9.87483 11.9859 9.98123 11.9964 10.0906C12.007 10.2 11.9941 10.3103 11.9586 10.415C11.9232 10.5199 11.8658 10.6172 11.7897 10.7014C11.7136 10.7857 11.6203 10.8553 11.5151 10.9061C11.41 10.957 11.295 10.9883 11.1768 10.998C11.1232 11.0007 11.0696 11.0007 11.016 10.998H11.0188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.004C11.481 4.03585 10.9917 4.25636 10.624 4.62401C10.2564 4.99165 10.0358 5.48105 10.004 6H9.996C9.96421 5.48103 9.74371 4.9916 9.37605 4.62395C9.0084 4.25629 8.51897 4.03579 8 4.004V3.996C8.51897 3.96421 9.0084 3.74371 9.37605 3.37605C9.74371 3.0084 9.96421 2.51897 9.996 2H10.004C10.0358 2.51895 10.2564 3.00835 10.624 3.37599C10.9917 3.74364 11.481 3.96415 12 3.996V4.004Z",
    fill: "url(#paint1_radial_9738_2946)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9738_2946",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.75314 6.09656) rotate(23.5242) scale(12.8135 123.789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#D21D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6B0BEA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9738_2946",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 3.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9738_2946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiOperator);
export default __webpack_public_path__ + "static/media/AI-Operator.d82521b647a1c050c2e45b5baf05251d.svg";
export { ForwardRef as ReactComponent };